// PolicyAdd.js 的保单录入字典基线。
// 这些值是保单数据契约的一部分，不能用页面自定义的近似枚举替代。
export const policyInsuranceType = [
  { value: 0, label: '类型' },
  { value: 10, label: '商业险' },
  { value: 11, label: '交强险' }
]

export const policyBusinessType = [
  { value: 0, label: '类型' },
  { value: 1, label: '新保' },
  { value: 2, label: '续保' },
  { value: 8, label: '转保' },
  { value: 32, label: '旧车首保' }
]

const businessTypeBySupplier = {
  9801: [
    { value: 1, label: '新保' },
    { value: 2, label: '续保自己' },
    { value: 4, label: '续保其他' },
    { value: 8, label: '转保' },
    { value: 32, label: '旧车首保' },
    { value: 256, label: '续保电网销' }
  ],
  9805: [
    { value: 1, label: '新保' },
    { value: 2, label: '续保自己' },
    { value: 4, label: '续保其他' },
    { value: 8, label: '转保' },
    { value: 32, label: '旧车首保' }
  ],
  9803: [
    { value: 1, label: '新保' },
    { value: 2, label: '续保' },
    { value: 8, label: '转保' },
    { value: 32, label: '旧车首保' }
  ]
}

export const policyUsageAttribute = [
  { value: 0, label: '使用性质' },
  { value: 1, label: '家用' },
  { value: 2, label: '非营业' },
  { value: 3, label: '营业' },
  { value: 7, label: '摩托车' },
  { value: 8, label: '拖拉机' },
  { value: 9, label: '特种' },
  { value: 10, label: '出租租赁' },
  { value: 11, label: '城市公交' },
  { value: 12, label: '公路客运' },
  { value: 13, label: '事业团体用车' }
]

const usageBySupplier = {
  9801: [
    { value: '000', label: '不区分营业非营业' },
    { value: '111', label: '出租租赁' },
    { value: '112', label: '城市公交' },
    { value: '113', label: '公路客运' },
    { value: '114', label: '旅游客运' },
    { value: '120', label: '营业货车' },
    { value: '180', label: '运输型拖拉机' },
    { value: '190', label: '其它营业车辆' },
    { value: '211', label: '家庭自用汽车' },
    { value: '212', label: '非营业企业客车' },
    { value: '213', label: '非营业机关、事业团体客车' },
    { value: '220', label: '非营业货车' },
    { value: '280', label: '兼用型拖拉机' },
    { value: '290', label: '其它非营业车辆' }
  ]
}

export const policyOwnershipAttribute = [
  { value: 0, label: '不限' },
  { value: 1, label: '私人' },
  { value: 4, label: '企业' },
  { value: 8, label: '机关' }
]

export const policyVehicleClass = [
  { value: 0, label: '车辆种类' },
  { value: 1, label: '客车' },
  { value: 2, label: '货车' },
  { value: 3, label: '挂车' },
  { value: 5, label: '出租车' },
  { value: 7, label: '特种车' },
  { value: 8, label: '摩托车' },
  { value: 9, label: '拖拉机、农用车' },
  { value: 10, label: '自卸' },
  { value: 11, label: '低速' },
  { value: 21, label: '特一' },
  { value: 22, label: '特二' },
  { value: 23, label: '特三' },
  { value: 24, label: '特四' },
  { value: 50, label: '牵引车' },
  { value: 51, label: '作业车' },
  { value: 99, label: '其他' }
]

export const policyTransferCar = [
  { value: 0, label: '未知' },
  { value: 2, label: '是' },
  { value: 1, label: '不是' }
]

export const policyTaxPayType = [
  { value: 0, label: '类型' },
  { value: 1, label: '正常缴税' },
  { value: 2, label: '免税' },
  { value: 3, label: '减税' },
  { value: 4, label: '已完税' },
  { value: 5, label: '不征' }
]

export const policyPaymentMode = [
  { value: 0, label: '请选择付款方式' },
  { value: 1, label: 'POS刷卡' },
  { value: 2, label: '微信支付' },
  { value: 3, label: '支付宝' },
  { value: 4, label: '网银支付' },
  { value: 5, label: '银行转账' },
  { value: 7, label: '支票方式' },
  { value: 8, label: '现金' },
  { value: 99, label: '其他' }
]

export const policyCertificateType = [
  { value: 0, label: '选择证件类型' },
  { value: 1, label: '身份证' },
  { value: 2, label: '护照' },
  { value: 3, label: '军官证' },
  { value: 5, label: '回乡证' },
  { value: 6, label: '台胞证' },
  { value: 7, label: '港澳通行证' },
  { value: 9, label: '临时身份证' },
  { value: 10, label: '户口簿' },
  { value: 11, label: '社保证' },
  { value: 12, label: '驾驶证' },
  { value: 13, label: '港澳身份证' },
  { value: 14, label: '赴台通行证' },
  { value: 15, label: '士兵证' },
  { value: 16, label: '港澳回乡证或台胞证' },
  { value: 17, label: '军人证' },
  { value: 18, label: '外国人永久居留身份证' },
  { value: 99, label: '其他' }
]

export const policyCompanyCertificateType = [
  { value: 0, label: '选择证件类型' },
  { value: 21, label: '税务登记证' },
  { value: 22, label: '企业代码' },
  { value: 23, label: '法人证书' },
  { value: 24, label: '营业执照' },
  { value: 25, label: '组织机构代码证' },
  { value: 30, label: '社会信用代码证' },
  { value: 41, label: '内部编码' },
  { value: 42, label: '工号' },
  { value: 99, label: '其他' }
]

export const policyCoverageLegacy = {
  old: {
    '10001': '车辆损失险',
    '10002': '商业第三者责任保险',
    '10003': '全车盗抢险',
    '10004': '司机座位责任险',
    '10005': '乘客座位责任险',
    '10006': '玻璃单独破碎险',
    '10007': '车身划痕损失险',
    '10008': '自燃损失险',
    '10009': '倒车镜车灯单独损坏险',
    '10010': '涉水行驶损失险',
    '10101': '车损不计免赔',
    '10102': '三者不计免赔',
    '10103': '盗抢不计免赔',
    '10104': '司机不计免赔',
    '10105': '乘客不计免赔',
    '10151': '司机乘客不计免赔',
    '10161': '附加险不计免赔',
    '10501': '机动车交通事故强制责任保险',
    '20201': '指定专修厂特约险',
    '20202': '新增设备损失险',
    '20203': '车上货物责任险',
    '20204': '交通事故精神损害赔偿险',
    '20205': '车辆停驶损失险',
    '20206': '附加油污污染责任保险',
    '20207': '代步车费用保险',
    '20208': '车载货物掉落责任险',
    '20209': '车辆重置特约险A款',
    '20210': '车辆重置特约险B款',
    '20211': '随车行李物品损失险',
    '20212': '换件特约险'
  },
  new: {
    '10001': '机动车损失保险',
    '10002': '机动车第三者责任保险',
    '10003': '机动车全车盗抢保险',
    '10004': '司机座位责任险',
    '10005': '乘客座位责任险',
    '10501': '机动车交通事故强制责任保险',
    '20201': '玻璃单独破碎险',
    '20202': '车身划痕损失险',
    '20203': '自燃损失险',
    '20204': '发动机涉水损失险',
    '20205': '指定修理厂险',
    '20206': '新增设备损失险',
    '20207': '车上货物责任险',
    '20208': '精神损害抚慰金责任险',
    '20209': '修理期间费用补偿险',
    '20210': '机动车损失保险无法找到第三方特约险',
    '20251': '特种车损失保险无法找到第三方特约险',
    '20252': '起重_装载_挖掘车辆损失扩展条款',
    '20253': '特种车辆固定设备_仪器损坏扩展条款',
    '30100': '基本险不计免赔',
    '30001': '车损不计免赔',
    '30002': '三者不计免赔',
    '30003': '盗抢不计免赔',
    '30004': '司机不计免赔',
    '30005': '乘客不计免赔',
    '30202': '车身划痕不计免赔',
    '30203': '自燃不计免赔',
    '30204': '发动机涉水不计免赔',
    '30206': '新增加设备不计免赔',
    '30207': '车上货物不计免赔',
    '30208': '精神损害抚慰金不计免赔',
    '30301': '不计免赔率险'
  }
}

export function getPolicyBusinessType (supplierId, partnerId) {
  const sid = Number(supplierId)
  const pid = Number(partnerId)
  // PolicyAdd.js has partner-specific labels for renewal options. Keep the
  // numeric values unchanged while matching the legacy display semantics.
  if (sid === 9801) return [{ value: 0, label: '类型' }].concat(businessTypeBySupplier[9801])
  if (sid === 9870) {
    return [{ value: 0, label: '类型' },
      { value: 2, label: '续保' },
      { value: 256, label: '续保电网销' },
      { value: 4, label: '续保其他' },
      { value: 8, label: '转保' },
      { value: 1, label: '新保' },
      { value: 32, label: '旧车首保' }
    ]
  }
  if (sid === 9818 && (pid === 20480 || pid === 10000)) {
    return [{ value: 0, label: '类型' },
      { value: 2, label: '续保自己' },
      { value: 4, label: '续保其他' },
      { value: 8, label: '转保' },
      { value: 1, label: '新保' },
      { value: 32, label: '旧车首保' }
    ]
  }
  if ((sid === 9805 || sid === 9803) && (pid === 20023 || pid === 20038)) {
    return sid === 9805 ? [{ value: 0, label: '类型' }].concat(businessTypeBySupplier[9805]) : [{ value: 0, label: '类型' },
      { value: 1, label: '新保' },
      { value: 2, label: '续保自己' },
      { value: 4, label: '续保其他' },
      { value: 8, label: '转保' },
      { value: 32, label: '旧车首保' }
    ]
  }
  if (sid === 9805 || sid === 9803) {
    return [
      { value: 0, label: '类型' },
      { value: 2, label: '续保' },
      { value: 4, label: '续保其他' },
      { value: 8, label: '转保' },
      { value: 1, label: '新保' },
      { value: 32, label: '旧车首保' }
    ]
  }
  return policyBusinessType
}

export function getPolicyUsageAttribute (supplierId) {
  const special = usageBySupplier[Number(supplierId)]
  return special ? [{ value: 0, label: '使用性质' }].concat(special) : policyUsageAttribute
}



// WEBPACK FOOTER //
// ./src/data/policyLegacy.js